/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface GeoBlockUiModuleBody
 */
export interface GeoBlockUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof GeoBlockUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBlockUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBlockUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBlockUiModuleBody
     */
    moduleType: GeoBlockUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof GeoBlockUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof GeoBlockUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof GeoBlockUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof GeoBlockUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof GeoBlockUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof GeoBlockUiModuleBody
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBlockUiModuleBody
     */
    legal: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GeoBlockUiModuleBodyModuleTypeEnum {
    GEO_BLOCK = 'GEO_BLOCK'
}



